import { loc } from "../../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import "../../internals/BaseHeader.js";
import "../../internals/BaseFooter.js";
import BaseForm from "../../internals/BaseForm.js";
import "../../internals/BaseFormWithPolling.js";
import "../../internals/BaseOktaVerifyChallengeView.js";
import BaseView from "../../internals/BaseView.js";
import "../../components/AuthenticatorEnrollOptions.js";
import "../../components/AuthenticatorVerifyOptions.js";
import "../../../../../packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js";
import "cross-fetch";
import "../../../../util/BrowserFeatures.js";
import "../../../../util/FactorUtil.js";
import "../../../../v1/views/admin-consent/ScopeList.js";
import "../../../../v1/views/consent/ScopeList.js";
import "../captcha/CaptchaView.js";
import IdentifierFooter from "../../components/IdentifierFooter.js";
import SignInWithDeviceOption from "../signin/SignInWithDeviceOption.js";
const Body = BaseForm.extend({
  title: function() {
    return loc("primaryauth.title", "login");
  },
  noButtonBar: true,
  initialize: function() {
    BaseForm.prototype.initialize.apply(this, arguments);
    this.add(SignInWithDeviceOption, {
      selector: ".o-form-fieldset-container",
      bubble: false,
      prepend: true,
      options: {
        isRequired: true
      }
    });
  }
});
const Footer = IdentifierFooter.extend({
  hasBackToSignInLink: false
});
var SignInDeviceView = BaseView.extend({
  Body,
  Footer
});
export { SignInDeviceView as default };
